<template>
  <main class="main">
    <section class="banner bgs-cover bgp-c">
      <div class="w-1000 h-100p m-a p-r">
        <h1 class="m-0 fs-50 fw-700 c-fff c-c p-a">Shipping & Rates</h1>
      </div>
    </section>
    <!-- banner:end -->
    <div class="crumb w-1000 m-a d-f jc-fs ai-c ff-asl fs-16">
      <a class="c-666" href="/">Home</a><span class="c-ccc"></span><a class="c-666" href="/support">Support Center</a
      ><span class="c-ccc"></span><a class="c-666 ff-as">Shipping & Rates</a>
    </div>
    <section class="aftersalespolicy mb-120">
      <div class="w-1000 m-a">
        <h2 class="m-0 fs-40 ta-c">SHIPPING & RATES</h2>
        <div class="policy-content lh-15 c-666 fs-16">
          <div ref="titleTxt" class="content-title d-f jc-sb ai-c fs-20 c-p c-000" @click="showContent">
            <strong>International Shipping Services Provided by FJD</strong
            ><i class="d-ib triangle-icon triangle-icon-000" ref="icon"></i>
          </div>
          <div class="content-box" v-show="showopt">
            <p>
              Shipping and tax charges for products purchased through the FJD Online Store may vary depending on the
              shipping address of your order.
            </p>
            <p>
              If your order meets certain requirements and the products you ordered will be shipped to an eligible
              international destination, you can enjoy our "Free Shipping" service.
            </p>
          </div>
          <div ref="titleTxt_1" class="content-title d-f jc-sb ai-c fs-20 c-p c-000" @click="showContent_1">
            <strong>Free International Shipping</strong
            ><i class="d-ib triangle-icon triangle-icon-000 tr-180" ref="icon_1"></i>
          </div>
          <div class="content-box" v-show="showopt_1">
            <p class="c-000 fw-700">
              You can identify eligibility through the "Free Shipping" message in the product details or on the search
              results page.
            </p>
            <p>
              • You can only have the products you ordered shipped to a shipping address located in an eligible
              international destination only.
            </p>
            <p>
              • Due to policies prevailing in some country/regions, orders exceeding 67KG in weight in the US, UK and EU
              may be split into multiple shipments.
            </p>
            <div class="white-box bgc-fff">
              <p class="c-ccc">
                Due to policies prevailing in some countries/regions, FJD will only offer "free shipping" to the
                following countries/regions for the time being (to be expanded continuously)
              </p>
            </div>
            <p class="ta-c c-000">Americas</p>
            <div class="white-box bgc-fff">
              <p class="ta-c c-666">United States</p>
            </div>
            <p class="ta-c c-000">Europe</p>
            <div class="white-box bgc-fff">
              <p class="c-ccc">
                Belgium, Bulgaria, Czech Republic, Denmark, Germany, Estonia, Ireland, Greece, Spain, France, Croatia,
                Italy, Cyprus, Latvia, Lithuania, Luxembourg, Hungary, Malta, Netherlands, Austria, Poland, Portugal,
                Romania, Slovenia, Slovakia, Finland, Sweden, United Kingdom
              </p>
            </div>
            <p class="c-000 fw-700">Note: you will not be entitled to free shipping services in the following cases:</p>
            <p>
              • Your shipping address is located in a country/region unreachable by DHL; please refer to the official
              DHL criteria for details.
            </p>
            <p>
              • You cancel items, combine orders or change shipping addresses etc., which may affect the eligibility of
              orders for free shipping.
            </p>
            <p class="c-000 fw-700">International orders and deliveries during COVID-19</p>
            <p>We provide shipping services worldwide, but delivery period may be longer than usual.</p>
            <p>
              Air transportation is restricted due to COVID-19, which affects our ability to deliver products quickly.
            </p>
            <p>
              International shipments may take longer than usual, and further restrictions may have on certain shipping
              destinations. You can find the latest delivery estimates at checkout.
            </p>
            <p>You can track orders and deliveries from the "Orders" section.</p>
          </div>

          <div ref="titleTxt_2" class="content-title d-f jc-sb ai-c fs-20 c-p c-000" @click="showContent_2">
            <strong>Customs, Duties and Taxes</strong
            ><i class="d-ib triangle-icon triangle-icon-000 tr-180" ref="icon_2"></i>
          </div>
          <div class="content-box" v-show="showopt_2">
            <p class="c-000 fw-700">
              When ordering from the FJD Online Store, it is your responsibility to ensure that the products can be
              legally imported to their destination.
            </p>
            <p>
              The consignee is the recorded importer and must comply with all laws and regulations of the destination.
            </p>
            <p>
              Orders shipped outside the US, UK or EU countries/regions may be subject to import duties, taxes and other
              charges imposed by the country/region of destination.
            </p>
            <p>
              Consignees of international shipments may be subject to such import taxes, duties and other charges
              imposed once the shipment arrives in the consignees' country/region.
            </p>
            <p>
              The consignee must pay additional fees for customs clearance and FJD has no control over and cannot
              predict these fees.
            </p>
            <p>For more information, please read "Margin".</p>
            <p class="c-000">
              Customs policies vary widely, so please contact your local customs districts for more information. Customs
              clearance procedures, if any, may result in delays beyond our initial estimated delivery period.
            </p>
            <br />
            <p class="c-000 fw-700">Notes:</p>
            <p>
              • Customs in some countries or regions require a specific form of identification from the importer of
              record prior to releasing the goods. You may be required to provide an identification number, such as a
              unique identification number, CPF or duty number.
            </p>
            <p class="c-000 fw-700">Countries that require an identification number include</p>
            <div class="white-box bgc-fff">
              <p class="c-ccc">
                Brazil, Chile, China, Taiwan, China, Costa Rica, Ecuador, El Salvador, Guatemala, Honduras, India,
                Israel, Nicaragua, Peru, Qatar, South Africa, South Korea, and Turkey.
              </p>
            </div>
          </div>
          <div ref="titleTxt_3" class="content-title d-f jc-sb ai-c fs-20 c-p c-000" @click="showContent_3">
            <strong>Margin</strong><i class="d-ib triangle-icon triangle-icon-000 tr-180" ref="icon_3"></i>
          </div>
          <div class="content-box" v-show="showopt_3">
            <p class="c-000 fw-700">
              FJD provides customers with estimates of customs duties, taxes and fees ("Import Fees") during checkout
              and clearance on your behalf in certain eligible countries and territories.
            </p>
            <p class="c-000 fw-700">Calculation of Charges</p>
            <p>
              When products you order from the FJD Online Store are to be shipped to destinations in the United States
              and beyond, an estimate of the Import Fee ("Margin") will be charged for those items in your order. Upon
              your authorization, the carrier or other agent will use the Margin to pay the Import Fee to the
              appropriate authorities at the destination on your (or the recipient's) behalf. The Import Fee is levied
              in accordance with the laws of the destination and payment of Import Fee is the responsibility of the
              importer.
            </p>
            <p>
              The Margin is an estimate of the taxes and duties that may apply. It may vary depending on the shipping
              method selected. The estimate may not be equal to the actual amount to be paid to customs. Customs
              regulations and rates applicable to certain commodities may change between the date when taxes and duties
              are estimated and the date when commodities are imported into the destination country. The tariff or duty
              rate is usually determined by the classification of the commodities, which varies by destination. If the
              actual cost of importation exceeds our estimated Margin, you will not be charged additional fees.
            </p>
            <p>
              Tariffs are calculated based on the customs regulations of the destination and generally based on the
              price of our products and shipping charges, plus any promotions. This allows the customs authorities of
              the destination country to obtain the exact import tariffs and taxes owed to them based on the actual
              value of the commodities. Please read "Customs, Duties and Taxes".
            </p>
            <p class="c-000 fw-700">Margin Refunds</p>
            <p>
              If the actual Import Fees are less than the Margin we collected on your behalf, you will automatically
              receive the difference related to the payment method used for your order. You will receive an email asking
              to confirm the amount of the refund. Refunds will be made available upon our receipt of a carrier invoice
              confirming the actual Import Fees. If a carrier invoice is not received within 180 days from the date of
              shipment, you will automatically receive a refund of the full amount of the Margin paid.
            </p>
          </div>
          <div ref="titleTxt_4" class="content-title d-f jc-sb ai-c fs-20 c-p c-000" @click="showContent_4">
            <strong>International Shipping Terms and Conditions</strong
            ><i class="d-ib triangle-icon triangle-icon-000 tr-180" ref="icon_4"></i>
          </div>
          <div class="content-box" v-show="showopt_4">
            <p class="c-000 fw-700">Each item in an order is sold by FJD or the agent designated for that item.</p>
            <p>
              • These items shipped to the United States and other countries may be subject to taxes, duties and charges
              imposed by the destination country (the "Import Fees"). The consignee of the goods is the importer of
              record in the country of destination and will assume all Import Fees.For each item for which Import Fees
              have been calculated, you authorize carrier ("Carrier") designated by FJD (if applicable) to act as your
              agent at the relevant customs and tax authorities in the destination country to handle customs clearance
              with respect to, process and remit the actual Import Fees for such items.
            </p>
            <p>
              • "Margin" represents an estimate of the Import Fees that will be levied on the items in your order. By
              placing an order, you agree to allow FJD to collect Margin for the applicable item(s) in the order. The
              Margin will be used to refund on your behalf the Import Fees paid by the Carrier to the appropriate
              authorities in the destination country on your behalf.
            </p>
            <p>
              • You further agree that the Carrier may disclose to FJD the actual Import Fees levied on the items you
              purchase from the JFD Online Store ("Actual Import Fees"). If the Margin exceeds the Actual Import Fees,
              FJD will refund the difference to you.
            </p>
            <p>
              • For gifts or other purchases made on behalf of other recipients, you also agree to grant the above
              authorization on behalf of the recipient(s) named in your order.
            </p>
            <p class="c-000">
              To obtain detailed information regarding the Actual Import Fees, or to obtain documentation or receipts
              related to customs clearance, you may contact the Carrier named in the shipment confirmation.
            </p>
            <p class="c-000">
              These terms and conditions are in addition to the standard conditions of use of the FJD website. Under
              these terms, title and risk of loss of the items pass to the recipient upon delivery to a common carrier
              in the United States.
            </p>
          </div>
          <div ref="titleTxt_5" class="content-title d-f jc-sb ai-c fs-20 c-p c-000" @click="showContent_5">
            <strong>Limitations</strong><i class="d-ib triangle-icon triangle-icon-000 tr-180" ref="icon_5"></i>
          </div>
          <div class="content-box" v-show="showopt_5">
            <p class="c-000 fw-700">For products to be shipped internationally, please note that:</p>
            <p>• Any warranty may be void;</p>
            <p>• After-sale service options may not be available;</p>
            <p>
              • Product manuals, instructions and safety warnings may not be in the language of the destination
              country/region;
            </p>
            <p>
              • The products (and accompanying materials) may not be designed to meet the standards, specifications and
              labeling requirements of the destination country/region and the products may not comply with the voltage
              and other electrical standards of the destination country/region (use an adapter or converter if
              required).
            </p>
            <p class="c-000">
              It is your responsibility to ensure that the products can be legally imported into the destination
              country. When ordering from the FJD Online Store, the recipient is the importer of record and must comply
              with all laws and regulations of the destination country/region.
            </p>
          </div>
          <div ref="titleTxt_6" class="content-title d-f jc-sb ai-c fs-20 c-p c-000" @click="showContent_6">
            <strong>Privacy</strong><i class="d-ib triangle-icon triangle-icon-000 tr-180" ref="icon_6"></i>
          </div>
          <div class="content-box" v-show="showopt_6">
            <p class="c-000 fw-700">
              Your privacy is of importance to us and we know that you care about how information about your order is
              used and shared.
            </p>
            <p>
              • Our international customers and customers purchasing goods subject to international shipping are called
              attention to that cross-border shipments must be opened and inspected by customs and/or postal
              authorities.
            </p>
            <p>
              • In addition, we may provide our international carriers with certain order, shipment and product
              information, such as titles, and the carriers may communicate this information to customs and/or postal
              authorities to facilitate customs clearance and compliance with local laws.
            </p>
            <p>
              • If the order is for a gift, the package will be marked "Gift", but the cost of the item will still be
              indicated on the customs form.
            </p>
            <p>• Customs requires that the value of the gift be indicated directly on the package.</p>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
  export default {
    data() {
      return {
        showopt: true,
        showopt_1: false,
        showopt_2: false,
        showopt_3: false,
        showopt_4: false,
        showopt_5: false,
        showopt_6: false
      }
    },
    created() {},
    mounted() {},
    methods: {
      showContent() {
        if (this.showopt === false) {
          //eslint-disable-line
          this.showopt = true
          this.$refs.icon.className = 'd-ib triangle-icon triangle-icon-000'
          this.$refs.titleTxt.style.borderBottom = 'none'
        } else {
          this.showopt = false
          this.$refs.titleTxt.style.borderBottom = '1px solid #eee'
          this.$refs.icon.className = 'd-ib triangle-icon triangle-icon-000 tr-180'
        }
      },
      showContent_1() {
        if (this.showopt_1 === false) {
          //eslint-disable-line
          this.showopt_1 = true
          this.$refs.icon_1.className = 'd-ib triangle-icon triangle-icon-000'
          this.$refs.titleTxt_1.style.borderBottom = 'none'
        } else {
          this.showopt_1 = false
          this.$refs.titleTxt_1.style.borderBottom = '1px solid #eee'
          this.$refs.icon_1.className = 'd-ib triangle-icon triangle-icon-000 tr-180'
        }
      },
      showContent_2() {
        if (this.showopt_2 === false) {
          //eslint-disable-line
          this.showopt_2 = true
          this.$refs.icon_2.className = 'd-ib triangle-icon triangle-icon-000'
          this.$refs.titleTxt_2.style.borderBottom = 'none'
        } else {
          this.showopt_2 = false
          this.$refs.titleTxt_2.style.borderBottom = '1px solid #eee'
          this.$refs.icon_2.className = 'd-ib triangle-icon triangle-icon-000 tr-180'
        }
      },
      showContent_3() {
        if (this.showopt_3 === false) {
          //eslint-disable-line
          this.showopt_3 = true
          this.$refs.icon_3.className = 'd-ib triangle-icon triangle-icon-000'
          this.$refs.titleTxt_3.style.borderBottom = 'none'
        } else {
          this.showopt_3 = false
          this.$refs.titleTxt_3.style.borderBottom = '1px solid #eee'
          this.$refs.icon_3.className = 'd-ib triangle-icon triangle-icon-000 tr-180'
        }
      },
      showContent_4() {
        if (this.showopt_4 === false) {
          //eslint-disable-line
          this.showopt_4 = true
          this.$refs.icon_4.className = 'd-ib triangle-icon triangle-icon-000'
          this.$refs.titleTxt_4.style.borderBottom = 'none'
        } else {
          this.showopt_4 = false
          this.$refs.titleTxt_4.style.borderBottom = '1px solid #eee'
          this.$refs.icon_4.className = 'd-ib triangle-icon triangle-icon-000 tr-180'
        }
      },
      showContent_5() {
        if (this.showopt_5 === false) {
          //eslint-disable-line
          this.showopt_5 = true
          this.$refs.icon_5.className = 'd-ib triangle-icon triangle-icon-000'
          this.$refs.titleTxt_5.style.borderBottom = 'none'
        } else {
          this.showopt_5 = false
          this.$refs.titleTxt_5.style.borderBottom = '1px solid #eee'
          this.$refs.icon_5.className = 'd-ib triangle-icon triangle-icon-000 tr-180'
        }
      },
      showContent_6() {
        if (this.showopt_6 === false) {
          //eslint-disable-line
          this.showopt_6 = true
          this.$refs.icon_6.className = 'd-ib triangle-icon triangle-icon-000'
          this.$refs.titleTxt_6.style.borderBottom = 'none'
        } else {
          this.showopt_6 = false
          this.$refs.titleTxt_6.style.borderBottom = '1px solid #eee'
          this.$refs.icon_6.className = 'd-ib triangle-icon triangle-icon-000 tr-180'
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .policy-content .content-title {
    border-bottom: 1px solid #eee;
  }
  .policy-content .content-title:first-child {
    border-color: transparent;
  }
  .policy-content .content-box {
    background-color: #f7f7f7;
  }
  .policy-content .content-title strong {
    flex: 1;
    font-weight: 500;
  }
  .triangle-icon-000 {
    width: 20px;
    height: 20px;
    background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cdefs%3E%3Cpath id='a' d='M0 0h20v20H0z'/%3E%3Cfilter color-interpolation-filters='auto' id='b'%3E%3CfeColorMatrix in='SourceGraphic' values='0 0 0 0 0.462745 0 0 0 0 0.462745 0 0 0 0 0.462745 0 0 0 1.000000 0'/%3E%3C/filter%3E%3C/defs%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 8.8L8.648.385a1.581 1.581 0 0 1 .001 2.267l-7.483 7.28L0 8.8zm1.173-1.14l7.585 7.377a1.583 1.583 0 0 1-.001 2.27L.01 8.793l1.165-1.134-.002.002z' fill='%23515151' fill-rule='nonzero' transform='rotate(90 6.538 11.923)' filter='url(%23b)'/%3E%3C/g%3E%3C/svg%3E");
  }
  @media screen and (min-width: 769px) {
    main {
      margin-top: 3.958vw;
    }
    .banner {
      height: 3.6rem;
      background-image: url('@/assets/images/support_0402/support_banner.jpg');
    }
    .crumb {
      padding: 68px 0 100px;
    }
    .aftersalespolicy h2 {
      margin-bottom: 70px;
      color: #222;
    }
    .policy-content a:hover {
      text-decoration: underline;
    }
    .policy-content .content-title {
      padding: 15px 0;
    }
    .policy-content .content-box {
      padding: 10px 15px;
      margin-bottom: 20px;
    }
    .white-box {
      padding: 5px 10px;
    }
    .w-1000 {
      width: 1000px;
      margin: 0 auto;
    }
    .fs-20 {
      font-size: 20px;
    }
    .fs-16 {
      font-size: 16px;
    }
    .lh-15 {
      line-height: 1.5;
    }
    .mb-120 {
      margin-bottom: 120px;
    }
    .fs-40 {
      font-size: 40px;
    }
  }
</style>
